import { VERSION } from './version';


export const environment: any = {
  production: false,
  envName: 'Homolog',
  version: VERSION + '-beta',
  GA_MEASUREMENT_ID: 'G-DKS0475FMZ',
  appBaseUrl: 'https://integrador.homolog.pinpag.com.br',
  xApiKey: 'F78mmlPU4a5KvmIEMfesS4qX5ltxywJC4Mc5eegV',
  sentry: 'https://ace4341d518341214402fe33f405fe40@o201079.ingest.us.sentry.io/4511897964576768',
  origins_api_key: {
    ITURAN: 'Lht36BFNHY44yUc8mjOX88NE0sre3g7K40i8UBk2',
    AUTOSCORE: 'dZGqkIjhWG41lrGMp0IT1a2ubCspj3GZ7yHnwnW2',
    WEBDESPACHANTES: 'F78mmlPU4a5KvmIEMfesS4qX5ltxywJC4Mc5eegV',
    MEGABEM: 'wLBB1uC8wvDKqfhWW9CJ5wg0GEYSGp7vC4pS1Z00',
    CDL: 'UEzOBeElcR6Q2tNUVuVO5LUJKUbg4tM4cJZWUaS1',
    PAYN: 'amKKFUYRgw6mlNZo5V4kA6C8151h237J2dC0f6Vc',
    AGILIZEAUTO: 'ucFnmcJ1TBaoRVStuJCOtaCYh3Mcbg1r3JNRJZTp',
    AUTOAVALIAR: 'OXVHeZw5lR8V8iDDhH8V07zXnbC9jELZ9No5KboJ',
    PROTEGEFACIL: 'ar8spKrjrU2xJLNU3ke4I8wYmZosaGzG4WezlyP1',
    CARROOK: 'bpRkdgE715bGAkY7EIS13P1Nbsc9pTP9l2KMGvt6',
    YOUDESP: 'SrDbCVqR5b2IpswswwGXp33ExsNDGMxV98AkjSa3',
    G30: 'Y4dLEx0gzg77fWBDTbveV2tqbigj8LB02h1xNSnJ',
    DESPAPAG: 'xPYbAjmrFe3aKgLojvq989rdWVMJ8zUN5CTNDldx',
    OLX: 'jMsB5gAPJWsZE2FDqMtl5EMzia64VIm4hD2hoxsd',
    AUTOCONF: 'N46MC2MfK94gc3tb4D3jf4fcvm93C1sC8jwF74uS'
  },
};
